import { get, post, postJson } from "@/utils/request.js";

export function regulation(params) {
	return postJson("/shop/vbao/regulation/regulate", params);
}

export function clearAll(params) {
	return postJson("/shop/vbao/admin/clear-all", params);
}

export function getAvailableAmount() {
	return get("/shop/vbao/regulation-pool/available");
}
